// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { IUploadFilesDetails } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";
import { IUploadFileStatus } from "../../models/applicationState";

/**
 * Reducer for recent projects. Actions handled:
 * LOAD_PROJECT_SUCCESS
 * SAVE_PROJECT_SUCCESS
 * DELETE_PROJECT_SUCCESS
 * SAVE_CONNECTION_SUCCESS
 * @param state - Array of recent projects
 * @param action - Action that was dispatched
 */
export const reducer = (state = 0, action: AnyAction) => {

    switch (action.type) {
        case ActionTypes.UPLOADED_FILE_COUNT_INCREMENT:
           return state + 1;
        case ActionTypes.CLEAR_UPLOADED_FILES_COUNT_SUCCESS:
           return null;
        // case ActionTypes.UPLOADING_FILES_STATUS_FAIL:
        //     return null;
         default:
            return state;
    }
};
